export default __webpack_public_path__ + "static/sparkle-support-b7c02f26b88f73b14f1c6fabf2b87807.jpg";